import { Modal } from "antd";
import React from "react";
import useRequest from "../../components/hooks/use-request";
import { CircleLoader } from "react-spinners";
import Icon from "../../assets/icons";
import { showToast } from "../../components/toast";

interface DeleteAdminProps {
  visible: boolean;
  handleClose: () => void;
  id: string;
}

const DeleteAdmin: React.FC<DeleteAdminProps> = ({
  visible,
  handleClose,
  id,
}) => {
  const userToken = localStorage.getItem("token");
  const { makeRequest: deleteAdminById, loading } = useRequest(
    `/admin/${id}`,
    "DELETE",
    {
      Authorization: `Bearer ${userToken}`,
    }
  );

  const handleDelete = async () => {
    const [response] = await deleteAdminById();
    if (response.status) {
      showToast(response.message, true, {
        position: "top-center",
      });
      handleClose();
      // Refresh the page to update the admin list
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    } else {
      showToast(
        response.message || "Something went wrong, please try again",
        false,
        {
          position: "top-center",
        }
      );
    }
  };

  return (
    <Modal
      open={visible}
      onCancel={handleClose}
      footer={null}
      centered
      width={400}>
      <div className='text-center'>
        <div className='flex justify-center mb-4'>
          <div className='w-16 h-16 bg-red-100 rounded-full flex items-center justify-center'>
            <Icon name='deleteIcon' className='text-red-600' />
          </div>
        </div>

        <h3 className='text-lg font-semibold text-gray-900 mb-2'>
          Delete Admin
        </h3>

        <p className='text-gray-600 mb-6'>
          Are you sure you want to delete this admin? This action cannot be
          undone.
        </p>

        <div className='flex gap-3 justify-center'>
          <button
            className='bg-red-500 hover:bg-red-600 text-white px-6 py-2 rounded-md font-medium transition-colors duration-200 min-w-[100px]'
            onClick={handleDelete}
            disabled={loading}>
            {loading ? (
              <CircleLoader color='#ffffff' loading={loading} size={16} />
            ) : (
              "Delete"
            )}
          </button>

          <button
            className='bg-gray-300 hover:bg-gray-400 text-gray-700 px-6 py-2 rounded-md font-medium transition-colors duration-200 min-w-[100px]'
            onClick={handleClose}
            disabled={loading}>
            Cancel
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteAdmin;
